<template>
    <GeneralBulkActions @dispatch-bulk-action="applyAction"/>
</template>

<script>
    import {getCookie} from "@/helpers/get-cookie";
    import {deleteElements} from "@/services/script";
    import _ from "lodash";
    import GeneralBulkActions from "@/components/commons/bulk-actions"
    import {mapGetters} from "vuex";

    export default {
        name: "ScriptsBulkActions",
        components: {GeneralBulkActions},
        computed: {
            ...mapGetters(['getBulkActions', 'getConstants', 'getModalConfirmation']),
        },
        methods: {
            applyAction(action) {
                if (action === 'delete') {
                    _.set(this.getModalConfirmation, 'origin', 'script')
                    _.set(this.getModalConfirmation, 'show', true)
                    _.set(this.getModalConfirmation, 'items', this.getBulkActions.selectedItems)
                    _.set(this.getModalConfirmation, 'action', 'delete')
                }
                _.set(this.getBulkActions, 'selectedItems', []);
            }
        }
    }
</script>

<style scoped>

</style>